const cardItems = [
  {
    title: '娱乐圈最新爆料特辑',
    desc: '聚焦娱乐圈最新动态，涵盖明星八卦、合约纠纷、片场内幕等一手资讯，黑料社独家整理。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20editorial%20with%20warm%20crimson%20glow%20highlighting%20geometric%20shapes%2C%20entertainment%20media%20theme%2C%20professional%20dark%20composition%20with%20dramatic%20contrast%2C%20no%20text%20or%20people&width=600&height=400&seq=cards-01-hlv&orientation=landscape',
    date: '2小时前',
    reads: '12.8万',
  },
  {
    title: '商业圈内幕深度调查',
    desc: '深度追踪知名企业背后的隐秘交易与资本运作，还原商业世界的真实博弈与暗流。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20corporate%20composition%20with%20amber%20accent%20lighting%20on%2C%20geometric%20skyscraper%20silhouettes%2C%20professional%20investigative%20journalism%20aesthetic%2C%20no%20text%20or%20people&width=600&height=400&seq=cards-02-hlv&orientation=landscape',
    date: '5小时前',
    reads: '9.6万',
  },
  {
    title: '科技圈数据安全专题',
    desc: '盘点近期科技公司数据泄露与隐私争议事件，分析行业安全现状与用户权益保护问题。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20tech%20theme%20with%20glowing%20circuit%20patterns%20in%20crimson%20and%20charcoal%2C%20cybersecurity%20atmosphere%2C%20modern%20digital%20dark%20editorial%20style%2C%20no%20text%20or%20people&width=600&height=400&seq=cards-03-hlv&orientation=landscape',
    date: '8小时前',
    reads: '7.3万',
  },
  {
    title: '网红圈争议事件全记录',
    desc: '梳理近期网红圈最具争议的事件脉络，包含多方回应与社区讨论精华，一文看懂来龙去脉。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20composition%20with%20dramatic%20contrasting%20warm%20and%20cool%20highlight%20accents%2C%20social%20media%20theme%2C%20modern%20editorial%20dark%20aesthetic%2C%20no%20text%20or%20people&width=600&height=400&seq=cards-04-hlv&orientation=landscape',
    date: '12小时前',
    reads: '15.1万',
  },
  {
    title: '社会事件真相追踪',
    desc: '持续关注引发广泛讨论的社会热点事件，整理多方信源还原最接近真实的版本。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20journalism%20composition%20with%20layered%20translucent%20amber%20and%20charcoal%20forms%2C%20dramatic%20shadow%20depth%2C%20professional%20news%20media%20aesthetic%2C%20no%20text%20or%20people&width=600&height=400&seq=cards-05-hlv&orientation=landscape',
    date: '1天前',
    reads: '20.4万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-900">
            精选专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            编辑精选的高质量专题内容，深度剖析热门事件
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item, i) => (
            <article
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-300/40 transition-all"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 leading-snug mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {item.desc}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" />
                    {item.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {item.reads}阅读
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}